<template>
  <div id="app">
    <router-view></router-view>
    <CookiesCountryBanner />
  </div>
</template>

<script>

import '@/assets/custom.css'
import CookiesCountryBanner from '@/components/CookiesCountryBanner.vue'

export default {
  name: 'App',
  components: {
    CookiesCountryBanner
  }
}
</script>

<style lang="scss">
@import 'bootstrap/scss/bootstrap';

:root {
  /* Variables of typography */
  --font-primary: 'Montserrat', 'Arial', sans-serif;
  --primary-orange: #FF9900;
  --secondary-orange: #FF6B00;
  --tertiary-orange: #F4A258;
  --primary-blue: #007BFF;
  --secondary-blue: #2A5F9E;
}

body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8f9fa;
}

#app {
  min-height: 100vh;
}

.btn-primary {
  background-color: var(--primary-blue);
  border-color: var(--primary-blue);
  &:hover {
    background-color: var(--secondary-blue);
    border-color: var(--secondary-blue);
  }
}

.btn-secondary {
  background-color: var(--primary-orange);
  border-color: var(--primary-orange);
  &:hover {
    background-color: var(--secondary-orange);
    border-color: var(--secondary-orange);
  }
}

.card {
  border: none;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* Standardized typography */
h1 {
  font-size: 3rem; /* 48px */
  font-weight: bold;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

h2 {
  font-size: 2.5rem; /* 40px */
  font-weight: bold;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.button {
  font-size: 2.2rem; /* 35px */
  font-weight: bold;
  color: #ffffff;
}

p {
  font-size: 1.75rem; /* 28px */
}

/* Call to action buttons */
.cta-button {
  padding: 2rem 2rem;
  border-radius: 30px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  width: 300px; /* Standard width in desktop */
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

/* Global styles for social icons */
.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  color: white;
  transition: all 0.3s ease;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.15);
  margin: 0.25rem;
}

.social-icon:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.social-icon.linkedin:hover {
  background: #0077b5;
  box-shadow: 0 5px 15px rgba(0, 119, 181, 0.4);
}

.social-icon.youtube:hover {
  background: #ff0000;
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
}

.social-icon.instagram:hover {
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);
  box-shadow: 0 5px 15px rgba(214, 36, 159, 0.4);
}

.social-icon.facebook:hover {
  background: #1877f2;
  box-shadow: 0 5px 15px rgba(24, 119, 242, 0.4);
}

.social-icon.tiktok:hover {
  background: #000000;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}

/* TikTok gradient effect */
.social-icon.tiktok:hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #25F4EE, #FE2C55, #000000);
  mix-blend-mode: screen;
}

.social-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 2rem 0;
}

.social-icons {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50px;
}

/* Global style for content-container */
.content-container {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin: 6rem;
}

/* Media queries for responsive */
@media (max-width: 480px) {
  h1 { font-size: 2rem; }
  h2 { font-size: 1.75rem; }
  .button { font-size: 1.5rem; }
  p { font-size: 1.25rem; }
  
  .content-container {
    margin: 1rem;
  }
}

@media (max-width: 768px) {
  h1 {
    font-size: 2rem; /* 32px */
  }
  h2 {
    font-size: 1.75rem; /* 28px */
  }
  .button {
    font-size: 1.5rem; /* 24px */
  }
  p {
    font-size: 1.25rem; /* 20px */
  }
  
  .cta-button {
    padding: 1rem 1rem;
    width: 100%;
  }
  .social-icons {
    gap: 2rem;
  }
  
  .social-container {
    margin: 0.5rem 0;
  }
}
</style>
